import { DecimalPipe } from '@angular/common';
import { inject, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatAdjusterValue',
  standalone: true,
})
export class FormatAdjusterValuePipe implements PipeTransform {
  private decimalPipe = inject(DecimalPipe)
  constructor() {

  }

  transform(value: number, digitsInfo = '1.1-1', isBusinessMinutes = false): string {
    if (value == 0) {
      return "-"
    }

    let endText = "";
    if (isBusinessMinutes) {
      endText = " h" // space intentional
    }
    return `${this.decimalPipe.transform(value, digitsInfo)!}${endText}`;
  }
}
